<script setup>
import { ref, defineProps, defineEmits } from "vue";

defineProps({
  variant: {
    type: String,
    default: "info",
  },
  message: {
    type: String,
    default: "",
  },
  dismissible: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(["close"]);

const isResetMessage = ref(true);

function close() {
  emit("close");
}
</script>
<template>
  <b-alert class="mb-3" :variant="variant" :dismissible="dismissible" v-model="isResetMessage" @closed="close">
    <div v-html="message"></div>
  </b-alert>
</template>
